import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserSelectionsService } from '../user-selections/user-selections.service';
import { ProductService } from '../product/product.service';
import { Product } from '../../types/product.type';
import { Observable, combineLatest, Subscription } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { ReservationService } from '../../services/reservation/reservation.service';
import { Reservation } from '../../types/booking.type';

@Injectable({
    providedIn: 'root'
})
export class RescheduleService {

    modelTreeRef: string;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private userSelectionService: UserSelectionsService,
        private productService: ProductService,
        private reservationService: ReservationService
    ) {
        this.init();
    }

    init() {
        this.activatedRoute.queryParams.pipe(
            takeWhile(queryParams => !queryParams.rescheduleId, true)
        ).subscribe(queryParams => {

            if (queryParams.rescheduleId) {

                this.reservationService.getReservation(queryParams.rescheduleId).subscribe(
                    (reservation: Reservation) => {

                        this.userSelectionService.set('startTime', reservation.start);
                        this.userSelectionService.set('endTime', reservation.end);
                        this.modelTreeRef = reservation.modelTreeRef;

                        const obs = combineLatest(
                            this.getVehicle(this.modelTreeRef)
                        ).pipe(
                            map(data => {

                                const vehicle = data[0];
                                if (vehicle) {
                                    return vehicle;
                                } else {
                                    return null;
                                }
                            })
                        ).subscribe((vehicle: Product) => {

                            if (vehicle && vehicle.enabled) {
                                this.userSelectionService.set('product', vehicle);
                                this.userSelectionService.set('modelTreeRef', queryParams.model);

                                setTimeout(() => {
                                    this.router.navigate(['/reschedule-booking', queryParams.rescheduleId], {
                                        skipLocationChange: true
                                    });
                                }, 100);
                            }

                        });

                    }
                );
            }
        });
    }

    /**
     * Given a vehicle identifier, return an observable of vehicle if its available for
     * real time test drives, else null.
     *
     * @param modelTreeRef Vehicle identifier.
     */
    private getVehicle(modelTreeRef: string): Observable<Product | undefined> {
        return this.productService.getListings().pipe(
            map(serieses => {
                const series = serieses.find(s => s.items.find(subProduct => subProduct.modelTreeRef === modelTreeRef));

                if (!series) {
                    return null;
                } else {
                    return series.items.find(subProduct => subProduct.modelTreeRef === modelTreeRef);
                }
            })
        );
    }

    /**
     * When given a modeltreeref, return a observable which emits a boolean value that
     * represents if the vehicle is valid for real-time booking.
     * @param modelTreeRef Vehicle identifier.
     */

}
